import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between items-center px-6" }
const _hoisted_2 = { class: "flex items-center gap-x-2" }
const _hoisted_3 = {
  key: 0,
  class: "flex gap-x-1"
}
const _hoisted_4 = { class: "font-semibold text-14px text-gray-lp-600 self-center" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row gap-2"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "pb-4 px-6"
}
const _hoisted_8 = { class: "border-t border-gray-lp-1300 flex flex-row gap-2 pt-3" }
const _hoisted_9 = { class: "flex-1 flex flex-row items-center gap-1 p-3 rounded-md bg-gray-lp-1500" }
const _hoisted_10 = { class: "text-gray-lp-300 font-semibold text-sm" }
const _hoisted_11 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_12 = { class: "flex-1" }
const _hoisted_13 = { class: "flex-1" }
const _hoisted_14 = { class: "flex-1" }
const _hoisted_15 = {
  key: 1,
  class: "px-6 pb-6 py-2"
}
const _hoisted_16 = { class: "flex flex-col border-t border-gray-lp-1300 pt-3 gap-3" }
const _hoisted_17 = { class: "bg-gray-lp-1500 flex flex-row items-center px-3 py-2 rounded-md" }
const _hoisted_18 = { class: "text-sm text-gray-lp-300 font-semibold ml-1" }
const _hoisted_19 = { class: "flex flex-row gap-4" }
const _hoisted_20 = {
  class: "flex flex-row items-center gap-3",
  style: {"flex":"2"}
}
const _hoisted_21 = {
  class: "bg-gray-lp-1200 flex flex-row items-center px-3 py-2 rounded-xl",
  style: {"flex":"2"}
}
const _hoisted_22 = {
  class: "flex flex-row items-center gap-2",
  style: {"flex":"2"}
}
const _hoisted_23 = { class: "text-sm text-gray-lp-300 font-semibold" }
const _hoisted_24 = { class: "text-xs text-gray-lp-800" }
const _hoisted_25 = { class: "rounded-xl flex flex-row gap-1 p-2 bg-purple-lp-100 items-center text-xs" }
const _hoisted_26 = { class: "text-gray-lp-600" }
const _hoisted_27 = { class: "flex flex-row gap-1 items-center text-" }
const _hoisted_28 = { class: "font-semibold text-gray-lp-300" }
const _hoisted_29 = {
  key: 2,
  class: "px-6 pb-6 py-2"
}
const _hoisted_30 = { class: "flex flex-col border-t border-gray-lp-1300 pt-3 gap-3" }
const _hoisted_31 = { class: "flex flex-row items-center gap-2 w-full" }
const _hoisted_32 = { class: "bg-gray-lp-1500 flex flex-row px-3 py-2 rounded-md items-center w-full" }
const _hoisted_33 = { class: "text-sm text-gray-lp-300 font-semibold ml-1 flex flex-row items-center" }
const _hoisted_34 = { class: "flex flex-row items-center gap-4" }
const _hoisted_35 = {
  class: "flex flex-row gap-3",
  style: {"flex":"2"}
}
const _hoisted_36 = {
  class: "bg-gray-lp-1200 flex flex-row items-center px-3 py-2 rounded-xl",
  style: {"flex":"2"}
}
const _hoisted_37 = {
  class: "flex flex-row items-center gap-2",
  style: {"flex":"2"}
}
const _hoisted_38 = { class: "text-sm text-gray-lp-300 font-semibold" }
const _hoisted_39 = { class: "text-xs text-gray-lp-800" }
const _hoisted_40 = { class: "rounded-xl flex flex-row gap-1 p-2 bg-purple-lp-100 items-center text-xs" }
const _hoisted_41 = { class: "text-gray-lp-600" }
const _hoisted_42 = { class: "flex flex-row gap-1 items-center text-" }
const _hoisted_43 = { class: "font-semibold text-gray-lp-300" }
const _hoisted_44 = { class: "flex flex-row items-center gap-2" }
const _hoisted_45 = {
  key: 0,
  class: "w-full flex flex-row gap-x-1"
}
const _hoisted_46 = { class: "font-semibold text-14px text-gray-lp-600 self-center" }
const _hoisted_47 = { class: "flex flex-row w-full pt-3 gap-3" }
const _hoisted_48 = { class: "w-full bg-gray-lp-1500 flex flex-row px-3 py-2 rounded-md items-center" }
const _hoisted_49 = { class: "w-full text-sm text-gray-lp-300 font-semibold ml-1 flex flex-row items-center" }
const _hoisted_50 = {
  key: 4,
  class: "border-t border-gray-lp-1300 px-6 flex flex-col pt-6 pb-2 gap-2",
  "data-testid": 'renewal-rate-card-period-change'
}
const _hoisted_51 = { class: "text-base font-semibold text-gray-lp-300" }
const _hoisted_52 = { class: "w-full" }
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row w-1/2 items-start" }, [
  /*#__PURE__*/_createVNode("div", { class: "flex flex-col items-center pt-1" }, [
    /*#__PURE__*/_createVNode("div", { class: "w-2.5 h-2.5 rounded-full bg-gray-lp-600" })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "flex-1 border-t-2 border-dashed border-gray-lp-1300 mx-2 mt-2" }),
  /*#__PURE__*/_createVNode("div", { class: "flex flex-col items-center pt-1" }, [
    /*#__PURE__*/_createVNode("div", { class: "w-2.5 h-2.5 rounded-full bg-gray-lp-600" })
  ])
], -1)
const _hoisted_54 = { class: "flex flex-row items-start pt-2" }
const _hoisted_55 = { class: "flex-1 flex-col gap-1" }
const _hoisted_56 = { class: "text-sm font-semibold text-gray-lp-300" }
const _hoisted_57 = { class: "text-sm font-normal text-gray-lp-300" }
const _hoisted_58 = { class: "flex-1 flex-col gap-1 -ml-5" }
const _hoisted_59 = { class: "text-sm font-semibold text-gray-lp-300" }
const _hoisted_60 = { class: "text-sm font-normal text-gray-lp-300" }
const _hoisted_61 = {
  key: 5,
  class: "border-t border-gray-lp-1300 px-6 flex flex-col py-6"
}
const _hoisted_62 = { class: "flex flex-row mb-4" }
const _hoisted_63 = { class: "flex flex-col pt-2" }
const _hoisted_64 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_65 = /*#__PURE__*/_createVNode("div", { class: "w-2.5 h-2.5 rounded-full bg-gray-lp-600" }, null, -1)
const _hoisted_66 = { class: "text-sm font-semibold text-gray-lp-300" }
const _hoisted_67 = { class: "flex flex-row items-center gap-2 pl-1" }
const _hoisted_68 = {
  "data-testid": "info-price-client-start-date",
  class: "text-sm text-gray-lp-600 border-l border-gray-lp-1300 border-dashed pl-3",
  style: {"padding-top":"4px","padding-bottom":"8px"}
}
const _hoisted_69 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_70 = /*#__PURE__*/_createVNode("div", { class: "w-2.5 h-2.5 rounded-full bg-gray-lp-600" }, null, -1)
const _hoisted_71 = { class: "text-sm font-semibold text-gray-lp-300" }
const _hoisted_72 = {
  class: "flex flex-row items-center gap-2",
  style: {"padding-left":"18px"}
}
const _hoisted_73 = {
  "data-testid": "info-price-client-end-date",
  class: "text-sm text-gray-lp-600",
  style: {"padding-top":"4px"}
}
const _hoisted_74 = { class: "text-sm text-gray-lp-300" }
const _hoisted_75 = { class: "text-sm text-gray-lp-300" }
const _hoisted_76 = { class: "flex flex-row mb-4" }
const _hoisted_77 = { class: "text-sm text-gray-lp-300" }
const _hoisted_78 = { class: "text-sm text-gray-lp-300" }
const _hoisted_79 = { class: "text-sm text-gray-lp-300" }
const _hoisted_80 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_81 = {
  key: 1,
  class: "flex flex-row gap-2 item text-sm text-gray-lp-300"
}
const _hoisted_82 = {
  key: 2,
  class: "text-sm my-1"
}
const _hoisted_83 = { class: "p-6 text-gray-lp-300 flex flex-col gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_PopupRenewRate = _resolveComponent("PopupRenewRate")!
  const _component_PopupChangeRate = _resolveComponent("PopupChangeRate")!
  const _component_ModalChangeInsurance = _resolveComponent("ModalChangeInsurance")!
  const _component_ModalChangePeriodPrice = _resolveComponent("ModalChangePeriodPrice")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", null, [
      _createVNode(_component_Card, {
        rounded: "xl",
        class: "py-5"
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_Title, {
                label: _ctx.cardTitle,
                fontSize: 20
              }, null, 8, ["label"]),
              (_ctx.isLiveRate)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _createVNode(_component_Icons, {
                      name: "reload",
                      class: "w-5 text-gray-lp-600"
                    }),
                    _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.lastProcessed')) + " " + _toDisplayString(_ctx.liveRateUpdatedAt), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isEmpty)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _withDirectives(_createVNode(_component_LpButton, {
                    "data-testid": "change-period-button",
                    onClick: _ctx.openChangePeriodePrice,
                    title: _ctx.$t('clientManagement.renewalRateCard.updatePeriod'),
                    textColor: "red-lp-300",
                    outline: "",
                    fontWeight: "bold",
                    disabled: _ctx.disableUbahPeriode
                  }, null, 8, ["onClick", "title", "disabled"]), [
                    [_vShow, _ctx.showButtonChangePeriode]
                  ]),
                  _withDirectives(_createVNode(_component_LpButton, {
                    onClick: _ctx.onShowPopupChangeRate,
                    disabled: !_ctx.decideDisableChangeRateButton,
                    title: _ctx.$t('clientManagement.renewalRateCard.changePrice'),
                    textColor: "red-lp-300",
                    outline: "",
                    fontWeight: "bold"
                  }, null, 8, ["onClick", "disabled", "title"]), [
                    [_vShow, _ctx.showButtonChangeRate]
                  ]),
                  _withDirectives(_createVNode(_component_LpButton, {
                    onClick: _ctx.changeInsurance,
                    title: _ctx.$t('clientManagement.renewalRateCard.changeInsurance'),
                    textColor: "red-lp-300",
                    outline: "",
                    fontWeight: "bold",
                    disabled: !_ctx.decideDisableChangeInsuranceButton
                  }, null, 8, ["onClick", "title", "disabled"]), [
                    [_vShow, _ctx.showButtonChangeInsurance]
                  ]),
                  _createVNode(_component_LpButton, {
                    onClick: _ctx.onShowPopupRenewRate,
                    title: _ctx.$t('clientManagement.renewalRateCard.newPrice'),
                    textColor: "white",
                    iconLeft: "plus-white",
                    fontWeight: "bold",
                    disabled: _ctx.isExpired || !_ctx.ableToRenewRatesByFlags
                  }, null, 8, ["onClick", "title", "disabled"]),
                  _withDirectives(_createVNode(_component_LpButton, {
                    title: _ctx.$t('clientManagement.renewalRateCard.changePrice'),
                    outline: "",
                    iconLeft: "ics_o_sync",
                    textColor: "red-lp-100 font-semibold",
                    fontWeight: "bold",
                    disabled: _ctx.isExpired || !_ctx.ableToUpdateLiveRateByFlags,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('renew-rate')))
                  }, null, 8, ["title", "disabled"]), [
                    [_vShow, false]
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_6, [
                  (_ctx.isApproved)
                    ? (_openBlock(), _createBlock(_component_Chips, {
                        key: 0,
                        label: _ctx.$t('clientManagement.renewalRateCard.accepted'),
                        isSubLabel: _ctx.isRenewalRatePartiallyBadge,
                        subLabel: _ctx.renewalRatePartiallyLabel,
                        rounded: "",
                        textColor: "green-lp-200",
                        color: "bg-green-lp-1200",
                        weight: "bold px-6 py-1",
                        textSize: 16
                      }, null, 8, ["label", "isSubLabel", "subLabel"]))
                    : _createCommentVNode("", true),
                  (_ctx.isRequested)
                    ? (_openBlock(), _createBlock(_component_Chips, {
                        key: 1,
                        label: _ctx.$t('clientManagement.renewalRateCard.requested'),
                        isSubLabel: _ctx.isRenewalRatePartiallyBadge,
                        subLabel: _ctx.renewalRatePartiallyLabel,
                        rounded: "",
                        textColor: "yellow-lp-100",
                        color: "bg-yellow-lp-400",
                        weight: "bold px-6",
                        textSize: 16
                      }, null, 8, ["label", "isSubLabel", "subLabel"]))
                    : _createCommentVNode("", true),
                  (_ctx.isRejected)
                    ? (_openBlock(), _createBlock(_component_Chips, {
                        key: 2,
                        label: _ctx.$t('clientManagement.renewalRateCard.rejected'),
                        isSubLabel: _ctx.isRenewalRatePartiallyBadge,
                        subLabel: _ctx.renewalRatePartiallyLabel,
                        rounded: "",
                        textColor: "red-lp-100",
                        color: "bg-red-lp-50",
                        weight: "bold px-6",
                        textSize: 16
                      }, null, 8, ["label", "isSubLabel", "subLabel"]))
                    : _createCommentVNode("", true),
                  (_ctx.isCancelled)
                    ? (_openBlock(), _createBlock(_component_Chips, {
                        key: 3,
                        label: _ctx.$t('clientManagement.renewalRateCard.cancelled'),
                        rounded: "",
                        textColor: "red-lp-100",
                        color: "bg-red-lp-50",
                        weight: "bold px-6",
                        textSize: 16
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (_ctx.isUploading)
                    ? (_openBlock(), _createBlock(_component_Chips, {
                        key: 4,
                        label: 
              `Upload ${_ctx.detailData.dataProcessedRenewal}/${_ctx.detailData.totalDataRenewal}`
            ,
                        isSubLabel: _ctx.isRenewalRatePartiallyBadge,
                        subLabel: _ctx.renewalRatePartiallyLabel,
                        rounded: "",
                        textColor: "yellow-lp-100",
                        color: "bg-yellow-lp-400",
                        weight: "bold px-6",
                        textSize: 16
                      }, null, 8, ["label", "isSubLabel", "subLabel"]))
                    : _createCommentVNode("", true),
                  (_ctx.isUploadingLiveRate)
                    ? (_openBlock(), _createBlock(_component_Chips, {
                        key: 5,
                        label: 
              `Upload ${_ctx.detailData.clientLiveRate.totalDataProcessed}/${_ctx.detailData.clientLiveRate.totalData}`
            ,
                        isSubLabel: _ctx.isRenewalRatePartiallyBadge,
                        subLabel: _ctx.renewalRatePartiallyLabel,
                        rounded: "",
                        textColor: "yellow-lp-100",
                        color: "bg-yellow-lp-400",
                        weight: "bold px-6",
                        textSize: 16
                      }, null, 8, ["label", "isSubLabel", "subLabel"]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          (!_ctx.isEmpty)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: !_ctx.isUploading || !_ctx.ratesRetryUploadConfig ? 'mt-3' : ''
              }, [
                (_ctx.isRequested && !_ctx.isPeriodRenewal)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode("div", _hoisted_8, [
                        _createVNode("div", _hoisted_9, [
                          _createVNode(_component_Icons, { name: "warning-circle-fill" }),
                          _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.ensurePriceInfoMatches')), 1)
                        ]),
                        _createVNode("div", _hoisted_11, [
                          _createVNode("div", _hoisted_12, [
                            _withDirectives(_createVNode(_component_LpButton, {
                              title: _ctx.$t('clientManagement.renewalRateCard.changePrice'),
                              textColor: "white",
                              fontWeight: "semibold",
                              customClass: "py-4"
                            }, null, 8, ["title"]), [
                              [_vShow, false]
                            ])
                          ]),
                          _createVNode("div", _hoisted_13, [
                            (_ctx.isErrorCustomRateFile && _ctx.canShowBtnAttachment)
                              ? (_openBlock(), _createBlock(_component_LpButton, {
                                  key: 0,
                                  title: _ctx.$t('clientManagement.renewalRateCard.downloadFailedFile'),
                                  textColor: "red-lp-100",
                                  fontWeight: "semibold",
                                  outline: "",
                                  iconLeft: "download",
                                  customClass: "py-4",
                                  onClick: _ctx.downloadErrorFile
                                }, null, 8, ["title", "onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_14, [
                            (_ctx.isCustomRateFile && _ctx.canShowBtnAttachment)
                              ? (_openBlock(), _createBlock(_component_LpButton, {
                                  key: 0,
                                  title: _ctx.$t('clientManagement.renewalRateCard.downloadAttachmentFile'),
                                  textColor: "red-lp-100",
                                  fontWeight: "semibold",
                                  outline: "",
                                  iconLeft: "download",
                                  customClass: "py-4",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (
                    _ctx.download(
                      _ctx.detailData.clientRenewalRate.clientFileCustomRate,
                      _ctx.detailData.clientRenewalRate.clientFileNameCustomRate
                    )
                  ))
                                }, null, 8, ["title"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isApproved)
                  ? (_openBlock(), _createBlock("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _createVNode("div", _hoisted_17, [
                          _createVNode(_component_Icons, { name: "check-green-fill" }),
                          _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.clientRequestAcceptedMessage')), 1)
                        ]),
                        _createVNode("div", _hoisted_19, [
                          _createVNode("div", _hoisted_20, [
                            _createVNode("div", _hoisted_21, [
                              _createVNode("div", _hoisted_22, [
                                _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.acceptedDate')), 1),
                                _createVNode("div", _hoisted_24, _toDisplayString(_ctx.statusRenewalUpdateAt), 1)
                              ]),
                              _createVNode("div", _hoisted_25, [
                                _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.acceptedBy')), 1),
                                _createVNode("div", _hoisted_27, [
                                  _createVNode(_component_Icons, { name: "icon-profile-fill" }),
                                  _createVNode("div", _hoisted_28, _toDisplayString(_ctx.statusRenewalUpdatedBy), 1)
                                ])
                              ])
                            ])
                          ]),
                          (_ctx.isCustomRateFile && _ctx.canShowBtnAttachment)
                            ? (_openBlock(), _createBlock(_component_LpButton, {
                                key: 0,
                                title: _ctx.$t('clientManagement.renewalRateCard.downloadAttachmentFile'),
                                textColor: "red-lp-100",
                                fontWeight: "semibold",
                                outline: "",
                                iconLeft: "download",
                                customClass: "w-full py-4",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (
                  _ctx.download(
                    _ctx.detailData.clientRenewalRate.clientFileCustomRate,
                    _ctx.detailData.clientRenewalRate.clientFileNameCustomRate
                  )
                ))
                              }, null, 8, ["title"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isRejectedOrCancelled)
                  ? (_openBlock(), _createBlock("div", _hoisted_29, [
                      _createVNode("div", _hoisted_30, [
                        _createVNode("div", _hoisted_31, [
                          _createVNode("div", _hoisted_32, [
                            _createVNode(_component_Icons, { name: "close-circle-fill" }),
                            _createVNode("div", _hoisted_33, _toDisplayString(_ctx.statusRenewalCaptions), 1)
                          ]),
                          (_ctx.isErrorCustomRateFile && _ctx.canShowBtnAttachment)
                            ? (_openBlock(), _createBlock(_component_LpButton, {
                                key: 0,
                                title: _ctx.$t('clientManagement.renewalRateCard.downloadFailedFile'),
                                textColor: "red-lp-100",
                                fontWeight: "semibold",
                                outline: "",
                                iconLeft: "download",
                                customClass: "py-4",
                                onClick: _ctx.downloadErrorFile
                              }, null, 8, ["title", "onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_34, [
                          _createVNode("div", _hoisted_35, [
                            _createVNode("div", _hoisted_36, [
                              _createVNode("div", _hoisted_37, [
                                _createVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.rejectedDate')), 1),
                                _createVNode("div", _hoisted_39, _toDisplayString(_ctx.statusRenewalUpdateAt), 1)
                              ]),
                              _createVNode("div", _hoisted_40, [
                                _createVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.rejectedBy')), 1),
                                _createVNode("div", _hoisted_42, [
                                  _createVNode(_component_Icons, { name: "icon-profile-fill" }),
                                  _createVNode("div", _hoisted_43, _toDisplayString(_ctx.statusRenewalUpdatedBy), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_44, [
                            _withDirectives(_createVNode(_component_LpButton, {
                              "data-testid": "change-period-button",
                              onClick: _ctx.openChangePeriodePrice,
                              title: _ctx.$t('clientManagement.renewalRateCard.updatePeriod'),
                              textColor: "red-lp-300",
                              outline: "",
                              fontWeight: "bold",
                              disabled: _ctx.disableUbahPeriode
                            }, null, 8, ["onClick", "title", "disabled"]), [
                              [_vShow, _ctx.showButtonChangePeriode]
                            ]),
                            _withDirectives(_createVNode(_component_LpButton, {
                              onClick: _ctx.onShowPopupChangeRate,
                              disabled: !_ctx.decideDisableChangeRateButton,
                              title: _ctx.$t('clientManagement.renewalRateCard.changePrice'),
                              textColor: "red-lp-300",
                              outline: "",
                              fontWeight: "bold"
                            }, null, 8, ["onClick", "disabled", "title"]), [
                              [_vShow, _ctx.showButtonChangeRate]
                            ]),
                            _withDirectives(_createVNode(_component_LpButton, {
                              onClick: _ctx.changeInsurance,
                              title: _ctx.$t('clientManagement.renewalRateCard.changeInsurance'),
                              textColor: "red-lp-300",
                              outline: "",
                              fontWeight: "bold",
                              disabled: !_ctx.decideDisableChangeInsuranceButton
                            }, null, 8, ["onClick", "title", "disabled"]), [
                              [_vShow, _ctx.showButtonChangeInsurance]
                            ]),
                            _createVNode(_component_LpButton, {
                              title: _ctx.$t('clientManagement.renewalRateCard.newPrice'),
                              textColor: "white",
                              fontWeight: "semibold",
                              customClass: "w-full py-4",
                              onClick: _ctx.onShowPopupRenewRate
                            }, null, 8, ["title", "onClick"]),
                            (_ctx.isCustomRateFile && _ctx.canShowBtnAttachment)
                              ? (_openBlock(), _createBlock(_component_LpButton, {
                                  key: 0,
                                  title: _ctx.$t('clientManagement.renewalRateCard.downloadAttachmentFile'),
                                  textColor: "red-lp-100",
                                  fontWeight: "semibold",
                                  outline: "",
                                  iconLeft: "download",
                                  customClass: "py-4",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.download(
                    _ctx.detailData.clientRenewalRate.clientFileCustomRate,
                    _ctx.detailData.clientRenewalRate.clientFileNameCustomRate
                  )))
                                }, null, 8, ["title"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (
            (_ctx.isUploading && (_ctx.isCancelUploadRate || _ctx.ratesRetryUploadConfig)) ||
              _ctx.isCancelUploadLiveRate
          )
                  ? (_openBlock(), _createBlock("div", {
                      key: 3,
                      class: ["flex flex-col px-6 pt-1", [{ 'pb-5': !_ctx.isLiveRate }]]
                    }, [
                      (!_ctx.isLiveRate)
                        ? (_openBlock(), _createBlock("div", _hoisted_45, [
                            _createVNode(_component_Icons, {
                              name: "reload",
                              class: "w-5 text-gray-lp-600"
                            }),
                            _createVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.lastProcessed')) + " " + _toDisplayString(_ctx.rateVersionUpdatedAt), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_47, [
                        _createVNode("div", _hoisted_48, [
                          _createVNode(_component_Icons, {
                            name: "warning-circle-fill",
                            class: "flex-shrink-0 w-6 h-6"
                          }),
                          _createVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.ensurePriceInfoMatchesWithExclamation')), 1),
                          (_ctx.isCancelUploadRate || _ctx.isCancelUploadLiveRate)
                            ? (_openBlock(), _createBlock(_component_LpButton, {
                                key: 0,
                                class: "ml-4",
                                customClass: "h-full",
                                title: "Batalkan Proses",
                                textColor: "red-lp-300",
                                color: "red-lp-300",
                                outline: "",
                                small: "",
                                onClick: _ctx.onConfirmCancelProcessUploadRate
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (_ctx.ratesRetryUploadConfig)
                            ? (_openBlock(), _createBlock(_component_LpButton, {
                                key: 1,
                                title: _ctx.$t('clientManagement.renewalRateCard.tryAgain'),
                                textColor: "white",
                                fontWeight: "semibold",
                                class: "ml-4",
                                customClass: "h-full",
                                onClick: _ctx.onOpenRetryConfirmationUploadRate,
                                disabled: _ctx.validationRetryButton
                              }, null, 8, ["title", "onClick", "disabled"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.isPeriodRenewal)
                  ? (_openBlock(), _createBlock("div", _hoisted_50, [
                      _createVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.pricePeriod')), 1),
                      _createVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _createVNode("div", _hoisted_54, [
                          _createVNode("div", _hoisted_55, [
                            _createVNode("div", _hoisted_56, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.start')), 1),
                            _createVNode("div", _hoisted_57, _toDisplayString(_ctx.formattedCurrentPeriodDate), 1)
                          ]),
                          _createVNode("div", _hoisted_58, [
                            _createVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.end')), 1),
                            _createVNode("div", _hoisted_60, _toDisplayString(_ctx.formattedProposedEndDate), 1)
                          ])
                        ])
                      ])
                    ]))
                  : (!_ctx.isLiveRate)
                    ? (_openBlock(), _createBlock("div", _hoisted_61, [
                        _createVNode("div", _hoisted_62, [
                          _createVNode(_component_DataWrapper, {
                            label: "Periode harga",
                            style: {"flex":"1"},
                            fontSize: 16
                          }, {
                            default: _withCtx(() => [
                              _createVNode("div", _hoisted_63, [
                                _createVNode("div", _hoisted_64, [
                                  _hoisted_65,
                                  _createVNode("div", _hoisted_66, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.start')), 1)
                                ]),
                                _createVNode("div", _hoisted_67, [
                                  _createVNode("div", _hoisted_68, _toDisplayString(_ctx.renewalRatePeriod.start), 1)
                                ]),
                                _createVNode("div", _hoisted_69, [
                                  _hoisted_70,
                                  _createVNode("div", _hoisted_71, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.end')), 1)
                                ]),
                                _createVNode("div", _hoisted_72, [
                                  _createVNode("div", _hoisted_73, _toDisplayString(_ctx.renewalRatePeriod.end), 1)
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_DataWrapper, {
                            label: _ctx.$t('clientManagement.renewalRateCard.priceCustomizationType'),
                            style: {"flex":"1"},
                            fontSize: 16
                          }, {
                            default: _withCtx(() => [
                              _createVNode("span", _hoisted_74, _toDisplayString(_ctx.priceTypeRenewRates), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_DataWrapper, {
                            label: _ctx.$t('clientManagement.renewalRateCard.customPrice'),
                            style: {"flex":"1"},
                            fontSize: 16
                          }, {
                            default: _withCtx(() => [
                              _createVNode("span", _hoisted_75, _toDisplayString(_ctx.renewalCustomRateValue), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _createVNode("div", _hoisted_76, [
                          _createVNode(_component_DataWrapper, {
                            label: _ctx.$t('clientManagement.renewalRateCard.price'),
                            style: {"flex":"1"},
                            fontSize: 16
                          }, {
                            default: _withCtx(() => [
                              _createVNode("span", _hoisted_77, _toDisplayString(_ctx.renewalRate), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_DataWrapper, {
                            label: _ctx.$t('clientManagement.renewalRateCard.weightCalculation'),
                            style: {"flex":"1"},
                            fontSize: 16
                          }, {
                            default: _withCtx(() => [
                              _createVNode("span", _hoisted_78, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.chargeableWeightRoundingActive')), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_DataWrapper, {
                            label: _ctx.$t('clientManagement.renewalRateCard.insuranceCalculation'),
                            style: {"flex":"1"},
                            fontSize: 16
                          }, {
                            default: _withCtx(() => [
                              _createVNode("span", _hoisted_79, _toDisplayString(_ctx.insuranceRateCalculation || "-"), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _createVNode(_component_DataWrapper, {
                          label: _ctx.$t('clientManagement.renewalRateCard.origin3lc'),
                          style: {"flex":"1"},
                          fontSize: 16
                        }, {
                          default: _withCtx(() => [
                            (_ctx.isCustomRate)
                              ? (_openBlock(), _createBlock("div", _hoisted_80, " - "))
                              : (_ctx.lcOptions.length)
                                ? (_openBlock(), _createBlock("div", _hoisted_81, [
                                    _createTextVNode(_toDisplayString(_ctx.lcOptions.length) + " ", 1),
                                    _createVNode("button", {
                                      class: "flex flex-row gap-1 items-center text-xs font-semibold text-red-lp-100",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.letterCodeModal = true))
                                    }, [
                                      _createVNode(_component_Icons, { name: "eye-red" }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.viewAll')), 1)
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock("div", _hoisted_82, _toDisplayString(_ctx.$t('clientManagement.renewalRateCard.all3lcs')), 1))
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]))
                    : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_Dialog, {
        modelValue: _ctx.letterCodeModal,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.letterCodeModal = $event)),
        title: _ctx.$t('clientManagement.renewalRateCard.origin3lc'),
        customBody: "renewal-rate-3lc",
        showOverflow: "",
        customHeight: "300px"
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_83, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lcOptions, (lc) => {
              return (_openBlock(), _createBlock("div", { key: lc }, _toDisplayString(lc), 1))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _createVNode(_component_PopupRenewRate, {
      modelValue: _ctx.showModalRenewRate,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.showModalRenewRate = $event)),
      clientName: _ctx.detailData.clientName,
      detailClient: _ctx.detailData
    }, null, 8, ["modelValue", "clientName", "detailClient"]),
    _createVNode(_component_PopupChangeRate, {
      key: _ctx.showModalChangeRate,
      modelValue: _ctx.showModalChangeRate,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.showModalChangeRate = $event)),
      clientName: _ctx.detailData.clientName,
      detailClient: _ctx.detailData,
      "is-edit": true
    }, null, 8, ["modelValue", "clientName", "detailClient"]),
    _withDirectives(_createVNode(_component_ModalChangeInsurance, {
      modelValue: _ctx.form,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form = $event)),
      clientId: _ctx.detailData.id,
      clientName: _ctx.detailData.clientName,
      error: _ctx.error,
      onOnClosePopup: _ctx.closeChangeInsurance,
      onOnSuccessEdit: _ctx.getDetailClientManagementV2
    }, null, 8, ["modelValue", "clientId", "clientName", "error", "onOnClosePopup", "onOnSuccessEdit"]), [
      [_vShow, _ctx.isUpdateInsurance]
    ]),
    _withDirectives(_createVNode(_component_ModalChangePeriodPrice, {
      startDate: _ctx.detailData?.clientCurrentRate?.clientRateversionStartDate,
      error: _ctx.error,
      rateVersionId: _ctx.detailData?.clientCurrentRate?.clientCustomRateId,
      onOnClosePopup: _ctx.openChangePeriodePrice,
      onOnSuccessEdit: _ctx.getDetailClientManagementV2
    }, null, 8, ["startDate", "error", "rateVersionId", "onOnClosePopup", "onOnSuccessEdit"]), [
      [_vShow, _ctx.changePeriodePrice]
    ])
  ], 64))
}